import type { FaireProductEntity } from "../../entity_types/product";

export const p_am7ra7ahxq: FaireProductEntity = {
  token: "p_am7ra7ahxq",
  type: "product",
  name: "Many Hearts Thanks Boxed Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/9c5c3ed99dbb3aa2b56a451ddb4465479bb6a071bdb96de168e49ca7c61daf58.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0817a0ae0e15ff15e69f00d8b9dd59e59492d84fb5e5cb69b89e6b34136a3011.png",
    "https://cdn.faire.com/fastly/7899f94814b7d9ad5b10dca8a952f6aae6982f311e18270b9e569ef1754b0338.jpeg",
  ],
  priceDollars: 11,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:06.063Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
